module.exports = __webpack_public_path__ + "static/media/jQuery.6b608b9a.png";